<template>
  <div style="height: 100%">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="列表" name="list">
        <el-form :inline="true" label-width="68px" class="searchListInput">
          <el-form-item label="菜单名称" prop="name">
            <el-input
              v-model="queryParams.name"
              placeholder="请输入菜单名称"
              clearable
              size="small"
              style="width: 150px"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item class="mb8">
            <el-button
              type="primary"
              icon="el-icon-search"
              size="mini"
              @click="handleQuery"
              class="elButtonSearch"
              >搜索
            </el-button>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="handleAddRoot"
              >新增
            </el-button>
          </el-form-item>
        </el-form>

        <el-table
          height="100%"
          style="width: fit-content"
          v-loading="loading"
          :data="tableData"
          border
          row-key="id"
          :tree-props="{ children: 'children' }"
          default-expand-all
        >
          <!--                    <el-table-column type="selection" width="55" align="center"/>-->
          <el-table-column
            label="菜单名称"
            align="center"
            prop="name"
            width="200"
          />
          <el-table-column
            label="菜单URI"
            align="center"
            prop="uri"
            width="350"
          />
          <el-table-column label="操作" align="center" width="250">
            <template slot-scope="scope">
              <!-- <el-button -->
              <el-button
                size="mini"
                type="text"
                icon="el-icon-plus"
                :disabled="scope.row.type == 0"
                @click="handleAddNode(scope.row)"
                >新增</el-button
              >
              <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="handleUpdate(scope.row)"
                >修改</el-button
              >
              <el-button
                size="mini"
                type="text"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <!-- 添加或修改参数配置对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogOpen" center>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="100px"
        label-position="top"
      >
        <el-row gutter="16">
          <el-col :span="12">
            <el-form-item>
              <el-radio-group v-model="radio">
                <el-radio label="1" :disabled="menuDisable">菜单</el-radio>
                <el-radio label="0" :disabled="buttonDisable">按钮</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row gutter="16">
          <el-col :span="8" v-show="false">
            <el-form-item label="上级id" prop="parentId">
              <el-input v-model="form.parentId" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上级" prop="parentName">
              <el-input v-model="form.parentName" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="名称" prop="name">
              <el-input v-model="form.name" placeholder="请输入名称" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row gutter="16">
          <el-col :span="8">
            <el-form-item label="排序" prop="orderBy">
              <el-input v-model="form.orderBy" placeholder="请输入序号" />
            </el-form-item>
          </el-col>
          <el-col :span="8" v-show="radio == 1 && !isLevelOne">
            <el-form-item label="URI" prop="uri">
              <el-input v-model="form.uri" placeholder="请输入URI" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row gutter="16">
          <el-col :span="8" v-show="radio == 1 && isLevelOne">
            <el-form-item label="图标" prop="iconClass">
              <el-input v-model="form.iconClass" placeholder="请输入图标" />
            </el-form-item>
          </el-col>
          <el-col :span="8" v-show="radio == 0">
            <el-form-item label="权限" prop="buttonPermission">
              <el-input
                v-model="form.buttonPermission"
                placeholder="请输入权限"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save">确 定</el-button>
        <el-button type="warning" @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { selectList, add, detail, remove } from '../../api/system/module';
import { translateObjectEmptyAttributeToNull } from '../../untils/func';

export default {
  name: 'Spring',
  data() {
    return {
      isLevelOne: true,
      buttonDisable: false,
      menuDisable: false,
      radio: '1',
      activeTab: 'list',
      // 遮罩层
      loading: true,
      // 字典表格数据
      tableData: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: '',
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        areaName: [
          { required: true, message: '井队名称不能为空', trigger: 'blur' },
        ],
      },

      dialogTitle: '新增',
      dialogOpen: false,
    };
  },

  created() {
    this.handleQuery();
  },

  methods: {
    cancel() {
      this.dialogOpen = false;
      this.form = {};
    },
    handleAddRoot() {
      this.form = {};
      this.dialogTitle = '新增';
      this.form.parentId = 0;
      this.form.parentName = '';
      this.buttonDisable = true;
      this.menuDisable = false;
      this.radio = '1';
      this.isLevelOne = true;
      this.dialogOpen = true;
    },

    handleAddNode(row) {
      this.form = {};
      this.dialogTitle = '新增';
      this.form.parentId = row.id;
      this.form.parentName = row.name;

      if (row.parentId == 0) {
        this.buttonDisable = true;
        this.menuDisable = false;
        this.radio = '1';
      } else {
        this.buttonDisable = false;
        this.menuDisable = true;
        this.radio = '0';
      }
      this.isLevelOne = false;

      this.dialogOpen = true;
    },

    async handleUpdate(row) {
      this.form = {};
      this.dialogTitle = '编辑';
      await this.viewDetail(row.id);
      this.radio = this.form.type;
      if (this.radio == '1') {
        this.buttonDisable = true;
        this.menuDisable = false;
      } else {
        this.buttonDisable = false;
        this.menuDisable = true;
      }

      if (this.form.parentId == 0) {
        this.isLevelOne = true;
      } else {
        this.isLevelOne = false;
      }

      this.dialogOpen = true;
    },

    async handleQuery() {
      this.loading = true;
      let param = this.queryParams;
      param = translateObjectEmptyAttributeToNull(param);
      const response = await selectList(param).then();
      this.tableData = response.data;
      this.loading = false;
    },

    async save() {
      this.form.type = this.radio;
      await add(this.form).then();
      this.msgSuccess('保存成功');
      this.dialogOpen = false;
      await this.handleQuery();
    },

    async viewDetail(id) {
      const response = await detail({ id: id }).then();
      this.form = response.data;
    },

    async handleDelete(row) {
      await this.$confirm('确定要删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then();

      await remove(row.id).then();
      this.msgSuccess('删除成功');
      this.dialogOpen = false;
      await this.handleQuery();
    },
  },
};
</script>

<style scoped lang="scss">
.el-tabs {
  padding: 0 10px;
  height: 100%;
  .el-tab-pane {
    height: calc(100% - 75px);
  }
}
.elButtonSearch {
  background: #00b741;
  border: 1px solid #00b741;

  &:hover {
    background: #39d636;
    border: 1px solid #39d636;
  }
}

.searchListInput {
  .el-input__inner {
    &::placeholder {
      color: #838689;
    }
  }

  .el-date-editor .el-range-input {
    &::placeholder {
      color: #838689;
    }
  }

  .el-form-item {
    margin-bottom: 0.25rem;
  }
}
</style>
